// extracted by mini-css-extract-plugin
export var bodySections = "_c6-8";
export var gray = "_c6-7";
export var green = "_c6-4";
export var iconContainer = "_c6-9";
export var iconWidgetContainer = "_c6-1";
export var phoneIcon = "_c6-2";
export var red = "_c6-5";
export var statusDot = "_c6-3";
export var widgetContainer = "_c6-0";
export var yellow = "_c6-6";